export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: '黄瓜视频是完全免费的吗？',
    answer: '是的，黄瓜视频的基本功能完全免费！你可以免费观看所有视频内容、使用基础剪辑工具、参与社区互动。我们也提供高级会员服务，会员可以享受高清下载、高级滤镜、专属模板等增值功能，但免费版已经能满足大部分用户的日常使用需求。',
  },
  {
    question: '如何在黄瓜视频上发布自己的作品？',
    answer: '发布作品非常简单！下载黄瓜视频APP后，注册账号，点击底部"+"号按钮即可开始创作。你可以直接拍摄视频，也可以从相册选择已有素材。我们的智能剪辑工具提供滤镜、转场、音乐、字幕等功能，三分钟就能做出一条精彩的短视频。编辑完成后添加标题和标签，点击发布即可。',
  },
  {
    question: '黄瓜视频支持哪些设备？',
    answer: '黄瓜视频目前支持iOS和Android两大主流移动平台，你可以在App Store和各大安卓应用商店搜索"黄瓜视频"下载。此外，我们也提供Web网页版，可以通过浏览器直接访问官网观看视频内容。未来还将推出iPad和桌面端的专属版本。',
  },
  {
    question: '创作者的收益是如何计算的？',
    answer: '黄瓜视频为创作者提供多元化的变现方式。主要有以下几种：1）播放量收益分成，根据视频的有效播放量计算；2）创作者激励计划，优质内容可获得额外奖金；3）粉丝打赏，观众可以直接打赏喜欢的创作者；4）品牌合作，我们帮助优秀创作者对接商业合作机会。具体收益标准可以在APP的创作中心查看。',
  },
  {
    question: '上传的视频有大小和时长限制吗？',
    answer: '基础用户单个视频最大支持500MB，时长上限为15分钟。认证创作者可以上传最大2GB的视频，时长上限为60分钟。我们支持MP4、MOV、AVI等主流视频格式。建议上传1080P以上的高清视频以获得更好的播放体验和推荐机会。',
  },
  {
    question: '如何保护我的视频版权？',
    answer: '黄瓜视频非常重视创作者的内容版权保护。我们提供以下保护措施：1）自动添加视频水印，防止盗用；2）原创声明功能，发布时可标记原创作品；3）侵权举报通道，发现盗用可一键举报，客服团队24小时内处理；4）区块链存证服务，为重要作品提供不可篡改的版权证明。',
  },
  {
    question: '遇到技术问题或需要帮助怎么办？',
    answer: '你可以通过以下渠道获得帮助：1）APP内"我的-帮助中心"提供了详细的使用教程和常见问题解答；2）在线客服，在APP内点击"联系客服"即可实时沟通；3）官方邮箱 support@huanggua.video，我们会尽快回复；4）官方社区"黄瓜创作者交流圈"，可以向其他创作者请教经验。',
  },
];